document.addEventListener('click', function (event) {
  const accordion = document.querySelector('.prod-accordion');
  const clickedElement = event.target;
  if (!accordion.contains(clickedElement)) {
    const accordionContents = document.querySelectorAll('.accordian-wrap');
    accordionContents.forEach(function (content) {
      content.classList.remove("active");
    });
  }
});
function accordian(){
  const accordions = document.querySelectorAll(".accordian-wrap");
  const openAccordion = (accordion) => {
    const content = accordion.querySelector(".accordian-content");
    accordion.classList.add("active");
    // content.style.maxHeight = content.scrollHeight + "px";
  };
  const closeAccordion = (accordion) => {
    const content = accordion.querySelector(".accordian-content");
    accordion.classList.remove("active");
    content.style.maxHeight = null;
  };
//   var first_accordian = document.querySelector(".accordian-wrap");
//   if(first_accordian){
//     var first_content = first_accordian.querySelector(".accordian-content");    
//   }
//   if(first_content){
//     first_content.style.maxHeight = first_content.scrollHeight + "px";
//   }
  accordions.forEach((accordion) => {
    const intro = accordion.querySelector(".accordian-title");
    const content = accordion.querySelector(".accordian-content");
    intro.onclick = () => {
      if (accordion.classList.contains('active')) {
        closeAccordion(accordion);
      } else {
        accordions.forEach((accordion) => closeAccordion(accordion));
        openAccordion(accordion);
      }
    };
  });
}
accordian();
document.addEventListener("shopify:section:load", function(event) {
  accordian();
});
document.querySelectorAll('.accordian-wrap').forEach((acco) => {
  if(window.innerWidth > 991){
    acco.addEventListener('mouseover',function(){
      const accordionContents = document.querySelectorAll('.accordian-wrap');
      accordionContents.forEach(function (content) {
        if(content.classList.contains('active')){
          content.classList.remove("active");
        }
      });
      // acco.classList.add("active");
    })
  }
})